import { requestData } from "./utils";

export default class ShortUrlModule {
  create(masked_url) {
    return requestData("POST", `/url`, {
      masked_url,
    });
  }

  getAll(query) {
    const {
      page,
      enterprise_id = "",
      entity_id = undefined,
      remote_url_starts_with = undefined,
      remote_url_contains = undefined,
    } = query;

    const page_size = query["page-size"] || query.pageSize;

    return requestData("GET", `/urls`, {
      page_size,
      page,
      enterprise_id,
      entity_id,
      remote_url_starts_with,
      remote_url_contains,
    });
  }

  requestQueryLink(query, link = "/query/url", abortSignal) {
    return requestData("GET", link, query, undefined, abortSignal);
  }
  get(url_id) {
    return requestData("GET", `/url/${url_id}`);
  }
  delete(url_id) {
    return requestData("DELETE", `/url/${url_id}`);
  }

  update(data) {
    const url_id = data.id;
    const requestBody = {
      ...data,
      time_last_updated: data.time_last_updated,
    };
    return requestData("PUT", `/url/${url_id}`, requestBody);
  }

  getShortUrlConfigLimit() {
    return requestData("GET", "/url/config/limits");
  }

  shortUrlConfig = {
    get: (enterprise_id) => {
      return requestData("GET", `/url/config/${enterprise_id}`);
    },
    update: (config, enterprise_id, time_last_updated) => {
      const requestBody = {
        ...config,
        time_last_updated: time_last_updated,
      };
      return requestData("PUT", `/url/config/${enterprise_id}`, requestBody);
    },
    add: (config, enterprise_id) => {
      return requestData("POST", `/url/config/${enterprise_id}`, config);
    },
  };
}
